import React from "react";

const LOGOS = [
  "ICGC",
  "International Academy",
  "Masjidul Istiqaamah",
  "OREF",
  "DMS",
  "Islamic Center of Maineville",
];

export default function Stats() {
  return (
    <section id="stats" className="section relative bg-[#F7F5F0]" data-testid="stats-section">
      <div className="aurora opacity-40" />
      <div className="container-x relative z-10">
        <div className="overline mb-8 text-center" style={{ color: "rgba(10,10,10,0.4)" }}>
          Trusted by ambitious teams
        </div>
        <div className="relative overflow-hidden border-y border-black/10 py-8">
          <div className="marquee">
            {[...LOGOS, ...LOGOS, ...LOGOS].map((l, i) => (
              <div
                key={i}
                className="font-display text-2xl md:text-3xl text-black/35 px-12 whitespace-nowrap flex items-center gap-12"
              >
                {l}
                <span className="text-[#C99B1A] text-sm">/</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
